module.exports = __webpack_public_path__ + "static/media/after-pay.3f63c5a0.svg";